"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_class_component_1 = __importDefault(require("vue-class-component"));
var vue_property_decorator_1 = require("vue-property-decorator");
var JoinedAtDatePicker = /** @class */ (function (_super) {
    __extends(JoinedAtDatePicker, _super);
    function JoinedAtDatePicker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = "quit-at-input";
        _this.value = _this.initValue;
        return _this;
    }
    JoinedAtDatePicker.prototype.onInitValueChanged = function () {
        this.value = this.initValue;
    };
    JoinedAtDatePicker.prototype.updateValue = function (value) {
        this.value = value;
        this.$emit("input", value);
    };
    JoinedAtDatePicker.prototype.isValid = function (emitValidation) {
        if (emitValidation === void 0) { emitValidation = false; }
        return true;
    };
    JoinedAtDatePicker.prototype.appendValidationClass = function () {
        var ref = this.$refs.quitAt;
        if (!ref || !ref.classList) {
            return;
        }
        if (this.isValid()) {
            ref.classList.remove("is-invalid");
            ref.classList.add("is-valid");
        }
        else {
            ref.classList.remove("is-valid");
            ref.classList.add("is-invalid");
        }
    };
    JoinedAtDatePicker.prototype.onBlur = function () {
        this.appendValidationClass();
    };
    __decorate([
        vue_property_decorator_1.Prop({ required: true })
    ], JoinedAtDatePicker.prototype, "initValue", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: false })
    ], JoinedAtDatePicker.prototype, "disabled", void 0);
    __decorate([
        vue_property_decorator_1.Watch("initValue")
    ], JoinedAtDatePicker.prototype, "onInitValueChanged", null);
    JoinedAtDatePicker = __decorate([
        vue_class_component_1.default({})
    ], JoinedAtDatePicker);
    return JoinedAtDatePicker;
}(vue_property_decorator_1.Vue));
exports.default = JoinedAtDatePicker;
